
define('inlineSvg!svgs/icon/arrow', function () {return '<span class="inline-arrow inline-icon"><svg width="24" height="10" viewBox="0 0 24 10"><path d="M0 .7l10.5 8.4 1.1.9 1.1-.9L23.2.7l-.5-.7-11.1 6.3L.6 0 0 .7z"/></svg></span>';});

